export function* logJSFunctionExecution(data: any) {
  return data;
}
